// Dev-only look-and-feel harness ribbon for the availability-probe respond page
// (/probe-respond/preview). Lets us exercise the page's rental-type and terminal
// state permutations via query params without a live token — mirrors
// WinBackPreviewRibbon.
// English-only internal tooling — deliberately not translated (this file lives
// under src/components/dev/**, the i18n allowlist's English-only dev carve-out).

export function ProbeRespondPreviewRibbon() {
  const link = (label: string, qs: string) => (
    <a href={`?${qs}`} className="underline hover:no-underline">
      {label}
    </a>
  );
  return (
    <div className="mb-6 rounded-md border border-dashed border-amber-400 bg-amber-50 px-4 py-3 text-xs text-amber-900">
      <span className="font-semibold uppercase tracking-wider">Preview</span>
      <span className="ml-3">Rental: {link("driving", "rental_type=driving")} · {link("chauffeured", "rental_type=chauffeured")} · {link("event", "rental_type=event")}</span>
      <span className="ml-3">State: {link("sent", "state=sent")} · {link("answered yes", "state=yes")} · {link("answered no", "state=no")} · {link("expired", "state=expired")}</span>
    </div>
  );
}
